import axios from "axios";
import { runLogoutCallback } from "./logoutHandler";
import { getAccessToken } from "../utils/auth0";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // ensures cookies are sent
});

// Request interceptor: Add Auth0 token to all requests
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const token = await getAccessToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.warn("Failed to add Auth0 token to request:", error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: handle 401 errors and parse blob JSON errors globally
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // 🔁 Handle 401 - trigger logout
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      await runLogoutCallback();
      return Promise.reject(error);
    }

    // 📦 If the server returned a blob error (e.g. from a binary request), try parsing it
    if (
      error.response?.data instanceof Blob &&
      error.response.data.type === "application/json"
    ) {
      try {
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        error.response.data = json; // ⬅️ overwrite blob with parsed JSON
      } catch (parseError) {
        console.warn("Failed to parse blob error response as JSON", parseError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
